import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import oauth from './oauth/oauth';
import login from './account/login';
import tokenCheck from './common/tokenCheck';
import activation from './account/activation';
import restoreAccount from './account/restoreAccount';
import role from './account/role';
import aliases from './account/aliases';
import accreditations from './accreditation/accreditations';
import activeModal from "./common/activeModal";
import department from './organization/department';
import departments from './organization/departments';
import { handleApiCallEpic } from './common/handleApiCall';
import titleLangs from './common/titleLangs';
import levels from './common/levels';
import location from './common/location';
import localization from "./common/localization";
import submitForm from './common/submitForm';
import organization from './organization/organization'
import organizations from './organization/organizations';
import staffMembers from "./organization/staffMembers";
import accreditationGroups from "./organization/accreditationGroups";
import accreditationGroup from "./organization/accreditationGroup";
import bulk from './accreditation/bulk';
import certifiedAccreditations from './applicantAccreditations/certifiedAccreditations';
import pendingAccreditations from './applicantAccreditations/pendingAccreditations';
import VIDs from './applicantAccreditations/VIDs';
import currencies from './finance/currencies';
import finance from './finance/finance';
import consents from './consent/consents';
import consent from './consent/consent';
import organizationConsents from './consent/organizationConsents';
import priorConsents from "./consent/priorConsents";
import priorConsent from "./consent/priorConsent";
import userData from './account/userData';
import userSettings from './account/userSettings';
import security from './account/security';
import applicantSelfStudyBooks from './applicantSelfStudy/applicantSelfStudyBooks';
import applicantSelfStudyBook from './applicantSelfStudy/applicantSelfStudyBook';
import bulkConsentRequests from './consent/bulkConsentRequests';
import certificate, { handleCryptoEpic } from './accreditation/certificate';
import orgCertificate from './organization/orgCertificate';
import notifications from './common/notifications';
import accreditationRequests from './applicantAccreditations/accreditationRequests';
import accreditationRequest from './applicantAccreditations/accreditationRequest';
import accreditationRequestOrgData from './applicantAccreditations/accreditationRequestOrgData';
import unreferencedAccreditationRequests from './accreditation/unreferencedAccreditationRequests';
import pendingAccreditationRequests from './accreditation/pendingAccreditationRequests';
import pendingAccreditationRequest from './accreditation/pendingAccreditationRequest';
import validatedDomains from './accreditation/validatedDomains';
import orgsWithoutCertificates from './organization/orgsWithoutCertificates';
import assistants from './assistant/assistants';
import businessAmbassadors from './businessAmbassador/businessAmbassadors';
import businessAmbassador from './businessAmbassador/businessAmbassador';
import commissions from './commission/commissions';
import duePayments from './systemPayments/duePayments';
import paymentsHistory from './systemPayments/paymentsHistory';
import companiesCredits from './systemPayments/companiesCredits';

const appReducer = combineReducers({
    oauth,
    login,
    tokenCheck,
    activation,
    restoreAccount,
    role,
    aliases,
    accreditations,
    activeModal,
    department,
    departments,
    titleLangs,
    levels,
    location,
    localization,
    submitForm,
    organization,
    organizations,
    staffMembers,
    accreditationGroups,
    accreditationGroup,
    bulk,
    certifiedAccreditations,
    pendingAccreditations,
    VIDs,
    currencies,
    finance,
    consents,
    consent,
    organizationConsents,
    priorConsents,
    priorConsent,
    userData,
    userSettings,
    security,
    applicantSelfStudyBooks,
    applicantSelfStudyBook,
    bulkConsentRequests,
    certificate,
    orgCertificate,
    notifications,
    accreditationRequests,
    accreditationRequest,
    accreditationRequestOrgData,
    unreferencedAccreditationRequests,
    pendingAccreditationRequests,
    pendingAccreditationRequest,
    orgsWithoutCertificates,
    assistants,
    businessAmbassadors,
    businessAmbassador,
    commissions,
    duePayments,
    paymentsHistory,
    companiesCredits,
    validatedDomains
});

export const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = {
            location: state.location,
            localization: state.localization,
            oauth: state.oauth
        }
    }

    return appReducer(state, action)
};

export const rootEpic = combineEpics(
    handleApiCallEpic,
    handleCryptoEpic
);


// WEBPACK FOOTER //
// ./src/reducers/index.js